<!--
 * @Description: 用户注册组件
 * @Author: hai-27
 * @Date: 2020-02-19 22:20:35
 * @LastEditors: hai-27
 * @LastEditTime: 2020-03-01 15:34:34
-->
<template>
  <div id="register">
    <el-dialog :title="$t('register.title')" width="300px" center :visible.sync="isRegister">
      <el-form
        :model="RegisterUser"
        :rules="rules"
        status-icon
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <el-form-item prop="name">
          <el-input
            prefix-icon="el-icon-user-solid"
            :placeholder="$t('register.usernamePlaceholder')"
            v-model="RegisterUser.name"
          ></el-input>
        </el-form-item>
        <el-form-item prop="pass">
          <el-input
            prefix-icon="el-icon-view"
            type="password"
            :placeholder="$t('register.passwordPlaceholder')"
            v-model="RegisterUser.pass"
          ></el-input>
        </el-form-item>
        <el-form-item prop="confirmPass">
          <el-input
            prefix-icon="el-icon-view"
            type="password"
            :placeholder="$t('register.confirmPasswordPlaceholder')"
            v-model="RegisterUser.confirmPass"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="medium" type="primary" @click="Register" style="width:100%;">{{ $t('register.button') }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "MyRegister",
  props: ["register"],
  data() {
    return {
      isRegister: false,
      RegisterUser: {
        name: "",
        pass: "",
        confirmPass: ""
      },
      rules: {
        name: [{ validator: this.validateName, trigger: "blur" }],
        pass: [{ validator: this.validatePass, trigger: "blur" }],
        confirmPass: [{ validator: this.validateConfirmPass, trigger: "blur" }]
      }
    };
  },
  watch: {
    register: function(val) {
      if (val) {
        this.isRegister = val;
      }
    },
    isRegister: function(val) {
      if (!val) {
        this.$refs["ruleForm"].resetFields();
        this.$emit("fromChild", val);
      }
    }
  },
  methods: {
    validateName(rule, value, callback) {
      if (!value) {
        return callback(new Error(this.$t('register.usernameRule')));
      }
      const userNameRule = /^[a-zA-Z][a-zA-Z0-9_]{4,15}$/;
      if (userNameRule.test(value)) {
        this.$axios
          .post("/api/users/findUserName", {
            userName: this.RegisterUser.name
          })
          .then(res => {
            if (res.data.code == "001") {
              this.$refs.ruleForm.validateField("checkPass");
              return callback();
            } else {
              return callback(new Error(this.$t('register.exists')));
            }
          })
          .catch(err => {
            return Promise.reject(err);
          });
      } else {
        return callback(new Error(this.$t('register.usernameRuleError')));
      }
    },
    validatePass(rule, value, callback) {
      if (value === "") {
        return callback(new Error(this.$t('register.passwordRule')));
      }
      const passwordRule = /^[a-zA-Z]\w{5,17}$/;
      if (passwordRule.test(value)) {
        this.$refs.ruleForm.validateField("checkPass");
        return callback();
      } else {
        return callback(new Error(this.$t('register.passwordRuleError')));
      }
    },
    validateConfirmPass(rule, value, callback) {
      if (value === "") {
        return callback(new Error(this.$t('register.confirmPasswordPlaceholder')));
      }
      if (this.RegisterUser.pass != "" && value === this.RegisterUser.pass) {
        this.$refs.ruleForm.validateField("checkPass");
        return callback();
      } else {
        return callback(new Error(this.$t('register.confirmRule')));
      }
    },
    Register() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          this.$axios
            .post("/api/users/register", {
              userName: this.RegisterUser.name,
              password: this.RegisterUser.pass
            })
            .then(res => {
              if (res.data.code === "001") {
                this.isRegister = false;
                this.notifySucceed(this.$t('register.success'));
              } else {
                this.notifyError(res.data.msg);
              }
            })
            .catch(err => {
              return Promise.reject(err);
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style scoped>
@media (max-width: 768px) {
  #register .el-dialog {
    width: 90% !important;
    max-width: 300px;
  }
}
</style>
